import { render, staticRenderFns } from "./investor.vue?vue&type=template&id=29d5ad26&scoped=true"
import script from "./investor.vue?vue&type=script&lang=js"
export * from "./investor.vue?vue&type=script&lang=js"
import style0 from "./investor.vue?vue&type=style&index=0&id=29d5ad26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d5ad26",
  null
  
)

export default component.exports